'use strict';

function controller ($rootScope, $element, $window, $attrs, listingService, searchResultsLinkService, pageStateService, alsService) {
    const ctrl = this;
    ctrl.$onInit = handleOnInit;
    ctrl.backToSearch = backToSearch;

    function backToSearch() {
        if (ctrl.backToMatchmakerUrl) {
            $window.location.assign(ctrl.backToMatchmakerUrl);
        } else {
            alsService.clickthru(ctrl.alsParams);
            pageStateService.push('event', {eventName: 'back-to-search-results'}, false);
            $window.location.assign(ctrl.backToSrpUrl);
        }
    }

    function handleOnInit () {

        listingService.getListing().then(listingResponse => {
            let listing = listingResponse.listingDetailDto;

            ctrl.backToMatchmakerUrl = searchResultsLinkService.getMatchMakerUrl();
            if (ctrl.backToMatchmakerUrl) {
              ctrl.linkText = 'Lifestyle Results';
            } else {
              ctrl.backToSrpUrl = searchResultsLinkService.getBackToSrpUrl(listing);

              if (ctrl.backToSrpUrl) {
                ctrl.linkText = 'Search Results';
              } else {
                ctrl.backToSrpUrl = searchResultsLinkService.getSeoUrl(listing);
                ctrl.linkText = `Shop other ${searchResultsLinkService.getSeoLinkText(listing)}`;
              }
            }

            ctrl.alsParams = {
                pageFromId: 2104,
                pageToId: 2102,
                listingId: listing.listingId
            };
        });
    }
}



controller.$inject = [
    '$rootScope',
    '$element',
    '$window',
    '$attrs',
    'listingService',
    'searchResultsLinkService',
    'pageStateService',
    'alsService'
];

export default controller;
